<template>
  <div class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
    <main>
      <div class="main_content align-items-center">
        <div class="row justify-content-between mb_40">
          <ClientHeaderTabs
            heading="Update Client"
            subheading="PBE Management Dashboard / Update Client / Ergo Eval"
            :tabs="tabs"
            :activeTab="activeTab"
            :handleTabClick="handleTabClick"
          />
          <div
            class="alche_btn tab_report toggle_switch list_card_switch mb_20 d-flex justify-content-sm-start justify-content-md-start"
          >
            <LanguageTabs
              :languages="languages"
              :currentLang="currentLang"
              @languageChanged="switchLanguage"
            />
          </div>
          <form
            method="post"
            @submit.prevent="updateClientErgoEval"
            data-vv-scope="updateClientForm"
          >
            <div class="card site_footer mb_24 editor_section">
              <div class="card_heading">
                <h4 class="heading2">Ergo Eval Summary Report Content</h4>
              </div>
              <div class="row client_accordian">
                <div class="row">
                  <div class="form-group">
                    <label class="form-label">Office Equipment Heading</label>
                    <ckeditor
                      :editor="editor"
                      v-validate="'required'"
                      data-vv-as="office equipment heading"
                      v-model="client_data.ergo_office_equipment_heading"
                      :config="editorConfig"
                      name="ergo_office_equipment_heading"
                      id="ergo_office_equipment_heading"
                      @blur="
                        onLostFocusEditor(
                          'updateClientForm.ergo_office_equipment_heading'
                        )
                      "
                    ></ckeditor>
                    <small
                      class="error text-danger"
                      v-show="
                        errors.has(
                          'updateClientForm.ergo_office_equipment_heading'
                        )
                      "
                    >
                      {{
                        errors.first(
                          "updateClientForm.ergo_office_equipment_heading"
                        )
                      }}
                    </small>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group">
                    <label class="form-label">Home Equipment Heading</label>
                    <ckeditor
                      :editor="editor"
                      v-validate="'required'"
                      data-vv-as="home equipment heading"
                      v-model="client_data.ergo_home_equipment_heading"
                      :config="editorConfig"
                      name="ergo_home_equipment_heading"
                      id="ergo_home_equipment_heading"
                      @blur="
                        onLostFocusEditor(
                          'updateClientForm.ergo_home_equipment_heading'
                        )
                      "
                    ></ckeditor>
                    <small
                      class="error text-danger"
                      v-show="
                        errors.has(
                          'updateClientForm.ergo_home_equipment_heading'
                        )
                      "
                    >
                      {{
                        errors.first(
                          "updateClientForm.ergo_home_equipment_heading"
                        )
                      }}
                    </small>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group">
                    <label class="form-label">WFH Safety Message</label>
                    <ckeditor
                      :editor="editor"
                      v-validate="'required'"
                      data-vv-as="wfh saftey message"
                      v-model="client_data.ergo_wfh_saftey_message"
                      :config="editorConfig"
                      name="ergo_wfh_saftey_message"
                      id="ergo_wfh_saftey_message"
                      @blur="
                        onLostFocusEditor(
                          'updateClientForm.ergo_wfh_saftey_message'
                        )
                      "
                    ></ckeditor>
                    <small
                      class="error text-danger"
                      v-show="
                        errors.has('updateClientForm.ergo_wfh_saftey_message')
                      "
                    >
                      {{
                        errors.first("updateClientForm.ergo_wfh_saftey_message")
                      }}
                    </small>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group">
                    <label class="form-label">Summary Report Footer</label>
                    <ckeditor
                      :editor="editor"
                      v-validate="'required'"
                      data-vv-as="summary report footer"
                      v-model="client_data.ergo_summary_report_footer"
                      :config="editorConfig"
                      name="ergo_summary_report_footer"
                      id="ergo_summary_report_footer"
                      @blur="
                        onLostFocusEditor(
                          'updateClientForm.ergo_summary_report_footer'
                        )
                      "
                    ></ckeditor>
                    <small
                      class="error text-danger"
                      v-show="
                        errors.has(
                          'updateClientForm.ergo_summary_report_footer'
                        )
                      "
                    >
                      {{
                        errors.first(
                          "updateClientForm.ergo_summary_report_footer"
                        )
                      }}
                    </small>
                  </div>
                </div>
                <div class="row">
                  <div class="site_footer">
                    <div class="client_btn_group action_btn">
                      <div class="row mt_24 justify-content-start">
                        <div class="col-md-10 col-lg-6 col-xl-4 text-start">
                          <button type="submit" class="btn btn_primary">
                            Update
                          </button>
                          <router-link :to="{ name: 'all_clients' }">
                            <button
                              href="javascript:void(0);"
                              class="btn btn_outline ml_24"
                            >
                              Cancel
                            </button>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import ClassicEditor from "ckeditor5-build-classic-image";
import commonFunction from "../../../../mixin/commonFunction";
import LanguageTabs from "../../../../components/LanguageTabs.vue";
import ClientHeaderTabs from "../../../../components/ClientHeaderTabs.vue";
export default {
  provide() {
    return { parentValidator: this.$validator };
  },
  name: "Client_Ergo_Eval",
  components: {
    LanguageTabs,
    ClientHeaderTabs,
  },
  mixins: [commonFunction],
  watch: {
    // Watch for route changes and update activeTab accordingly
    $route(to) {
      switch (to.name) {
        case "edit_client":
          this.activeTab = "update-client";
          break;
        case "edit_client_self_assessment":
          this.activeTab = "self-assessment";
          break;
        case "edit_client_ergo_eval":
          this.activeTab = "ergo-eval";
          break;
        case "edit_client_self_assessment_lab":
          this.activeTab = "self-assessment-lab";
          break;
        case "edit_client_ergo_eval_lab":
          this.activeTab = "ergo-eval-lab";
          break;
        case "edit_client_cms":
          this.activeTab = "cms";
          break;
        default:
          this.activeTab = "update-client";
      }
    },
  },
  data() {
    return {
      activeTab: "ergo-eval",
      tabs: [
        { id: "update-client", label: "Update Client" },
        { id: "cms", label: "CMS" },
        { id: "self-assessment", label: "Self-Assessment" },
        { id: "ergo-eval", label: "Ergo Eval" },
        { id: "self-assessment-lab", label: "Self-Assessment - Lab" },
        { id: "ergo-eval-lab", label: "Ergo Eval - Lab" },
      ],
      languages: [
        { code: "en", label: "English" },
        { code: "es", label: "Spanish" },
        { code: "pt", label: "Portuguese" },
        { code: "cn", label: "Chinese" },
        { code: "ja", label: "Japanese" },
        { code: "ko", label: "Korean" },
        { code: "fr", label: "French" },
        { code: "de", label: "German" },
      ],
      currentLang: "pt",
      summaryReportInfo: this.$store.getters["ClientsConfig/summaryReportInfo"],
      editor: ClassicEditor,
      editorData:
        "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>",
      editorConfig: {
        // The configuration of the editor.
        toolbar: {
          items: [
            "heading",
            "|",
            "bold",
            "italic",
            "link",
            "|",
            "undo",
            "redo",
            "alignment",
          ],
        },
        link: {
          // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
          addTargetToExternalLinks: true,
        },
      },
      base_url: null,
      client_data: {
        id: "",
        u_id: "",
        ergo_office_equipment_heading: null,
        ergo_home_equipment_heading: null,
        ergo_wfh_saftey_message: null,
        ergo_summary_report_footer: null,
        report_type: "ergo-eval",
        lang: "pt",
      },
    };
  },
  beforeMount() {
    if (this.$route.params.id == undefined) {
      // Json functions are used so that original values doesnt get changed
      this.client_data.ergo_office_equipment_heading = JSON.parse(
        JSON.stringify(this.summaryReportInfo.ergo_office_equipment_heading)
      );
      this.client_data.ergo_home_equipment_heading = JSON.parse(
        JSON.stringify(this.summaryReportInfo.ergo_home_equipment_heading)
      );
      this.client_data.ergo_wfh_saftey_message = JSON.parse(
        JSON.stringify(this.summaryReportInfo.ergo_wfh_saftey_message)
      );
      this.client_data.ergo_summary_report_footer = JSON.parse(
        JSON.stringify(this.summaryReportInfo.ergo_summary_report_footer)
      );
    }
    const langCode = this.$route.name.split("_").pop();
    this.getSingleClient(
      this.$route.params.id,
      this.client_data.report_type,
      langCode
    );
  },
  mounted() {
    this.base_url = process.env.VUE_APP_API_URL;
  },
  methods: {
    switchLanguage(languageCode) {
      this.$parent.$refs.fullpageloader.is_full_page_loader = true;

      const clientId = this.$route.params.id;
      const routeName = `edit_client_ergo_eval_${languageCode}`;

      this.$router
        .push({
          name: routeName,
          params: { id: clientId },
        })
        .then(() => {
          this.$parent.$refs.fullpageloader.is_full_page_loader = false;
        })
        .catch(() => {
          // Optional: fallback route or error handling
          this.$parent.$refs.fullpageloader.is_full_page_loader = false;
        });
    },
    handleTabClick(tab) {
      this.$parent.$refs.fullpageloader.is_full_page_loader = true;
      this.activeTab = tab.id;

      const clientId = this.$route.params.id;
      switch (tab.id) {
        case "edit-client":
          this.$router
            .push({
              name: "edit_client",
              params: { id: clientId },
            })
            .then(() => {
              this.$parent.$refs.fullpageloader.is_full_page_loader = false;
            });
          break;
        case "self-assessment":
          this.$router
            .push({
              name: "edit_client_self_assessment_en",
              params: { id: clientId },
            })
            .then(() => {
              this.$parent.$refs.fullpageloader.is_full_page_loader = false;
            });
          break;
        case "self-assessment-lab":
          this.$router
            .push({
              name: "edit_client_self_assessment_lab",
              params: { id: clientId },
            })
            .then(() => {
              this.$parent.$refs.fullpageloader.is_full_page_loader = false;
            });
          break;
        case "ergo-eval-lab":
          this.$router
            .push({
              name: "edit_client_ergo_eval_lab",
              params: { id: clientId },
            })
            .then(() => {
              this.$parent.$refs.fullpageloader.is_full_page_loader = false;
            });
          break;
        case "cms":
          this.$router
            .push({
              name: "edit_client_cms",
              params: { id: clientId },
            })
            .then(() => {
              this.$parent.$refs.fullpageloader.is_full_page_loader = false;
            });
          break;
        default:
          this.$router
            .push({
              name: "edit_client",
              params: { id: clientId },
            })
            .then(() => {
              this.$parent.$refs.fullpageloader.is_full_page_loader = false;
            });
      }
    },
    onLostFocusEditor(id) {
      this.$parent.onLostFocusEditor(id);
    },
    getSingleClient(id, type_of_assessment, langCode = "pt") {
      var _this = this;
      let config = {
        method: "get",
        url: `${process.env.VUE_APP_API_URL}/api/edit-client-reports/${type_of_assessment}/${id}/${langCode}`,
        withCredentials: true,
      };
      _this
        .axios(config)
        .then(({ data }) => {
          if (data.success) {
            var decodedData = _this.decodeAPIResponse(data.data);
            _this.client_data.id = this.$route.params.id;
            _this.client_data.u_id = this.$route.params.id;

            _this.client_data.ergo_office_equipment_heading =
              decodedData.records.ergo_office_equipment_heading != null
                ? decodedData.records.ergo_office_equipment_heading
                : JSON.parse(
                    JSON.stringify(
                      this.summaryReportInfo.ergo_office_equipment_heading
                    )
                  );

            _this.client_data.ergo_home_equipment_heading =
              decodedData.records.ergo_home_equipment_heading != null
                ? decodedData.records.ergo_home_equipment_heading
                : JSON.parse(
                    JSON.stringify(
                      this.summaryReportInfo.ergo_home_equipment_heading
                    )
                  );

            _this.client_data.ergo_wfh_saftey_message =
              decodedData.records.ergo_wfh_saftey_message != null
                ? decodedData.records.ergo_wfh_saftey_message
                : JSON.parse(
                    JSON.stringify(
                      this.summaryReportInfo.ergo_wfh_saftey_message
                    )
                  );

            _this.client_data.ergo_summary_report_footer =
              decodedData.records.ergo_summary_report_footer != null
                ? decodedData.records.ergo_summary_report_footer
                : JSON.parse(
                    JSON.stringify(
                      this.summaryReportInfo.ergo_summary_report_footer
                    )
                  );
          } else {
            _this.$toast.error(data.message, {
              position: "top-right",
              duration: 5000,
            });
            _this.$router.push({
              name: "all_clients",
            });
          }
        })
        .catch((response) => {
          console.log("catch", response);
          _this.$router.push({
            name: "all_clients",
            params: { errorMsg: response.data.error },
          });
        });
    },
    updateClientErgoEval() {
      var _this = this;

      _this.$validator.validateAll("updateClientForm").then((isValid) => {
        if (isValid) {
          _this.$parent.$refs.fullpageloader.is_full_page_loader = true;
          if (_this.client_data.u_id) {
            let config = {
              method: "put",
              url:
                process.env.VUE_APP_API_URL +
                "/api/update-client-report/" +
                _this.client_data.u_id,
              headers: {
                "Content-Type": "application/json",
              },
              withCredentials: true,
              data: {
                request_data: this.encodeAPIRequestWithImages(
                  _this.client_data
                ),
              },
            };
            _this
              .axios(config)
              .then(({ data }) => {
                _this.$parent.$refs.fullpageloader.is_full_page_loader = false;
                _this.$toast.success(data.message, {
                  position: "top-right",
                  duration: 5000,
                });
              })
              .catch((err) => {
                _this.$parent.$refs.fullpageloader.is_full_page_loader = false;
                if (err.response.status == 422) {
                  var err1 = "";
                  for (let x in err.response.data.errors) {
                    err1 += err.response.data.errors[x];
                    err1 += "<br>";
                  }
                  _this.$toast.error(err1, {
                    position: "top-right",
                    duration: 5000,
                  });
                } else if (err.response.status == 401) {
                  _this.tokenExpired();
                } else {
                  _this.$toast.error(err.response.data.error, {
                    position: "top-right",
                    duration: 5000,
                  });
                }
              });
          } else {
            _this.$router.push({
              name: "404",
              params: { errorMsg: "URL Not found." },
            });
          }
        } else {
          console.log("Error In Validation", _this.errors);
          const nodeList = document.querySelectorAll(".error");
          nodeList.forEach((element) => {
            if (element.style.display != "none") {
              var acc = element.closest(".accordion-collapse");
              if (acc != null) acc.classList.add("show");
            }
          });
        }
      });
    },
  },
};
</script>
